module.exports = __webpack_public_path__ + "img/simpro-logo-blue.svg";